import { PlaceholderPage } from './PlaceholderPage';

export const ImportTemplatesOpeningBalancesPage = () => <PlaceholderPage title="Import Templates & Opening Balances" />;
